import { render, staticRenderFns } from "./TabGanttTask.vue?vue&type=template&id=0a7d0998&scoped=true&"
import script from "./TabGanttTask.vue?vue&type=script&lang=js&"
export * from "./TabGanttTask.vue?vue&type=script&lang=js&"
import style0 from "./TabGanttTask.vue?vue&type=style&index=0&id=0a7d0998&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7d0998",
  null
  
)

export default component.exports